/** The single theme axis: light or dark. Accent is a fixed wine (no picker). */
export type Mode = "light" | "dark";

/**
 * First-load theme resolution. An explicit stored choice always wins; otherwise
 * honor the OS `prefers-color-scheme`, defaulting to dark when it is not light.
 * Pure so it can be unit-tested without a DOM.
 */
export function resolveMode(stored: string | null, prefersLight: boolean): Mode {
  if (stored === "light" || stored === "dark") return stored;
  return prefersLight ? "light" : "dark";
}
